import { setDashboard } from "../../Redux/DashboardSlice";
import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import DashboardService from "../../Services/http/DashboardService";

export const GetDashboard = async (dispatch, accountId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await DashboardService.getDashboard(accountId);
  if (response && response["monthly_earnings"]) {
    dispatch(setDashboard(response));
   
  }
  dispatch(setIsActiveSpinner(false));
};
